import React from 'reactn'
import { Box, Image, IconButton } from '@chakra-ui/react'
// import { useBreakpointValue } from "@chakra-ui/react"
// import CartIcon from '../../../ingmarson-shopiify-stripe/src/icons/cart';

export function CartButton({ updateGlobal, globalState, store }) {
  if (!store && globalState) {
    store = globalState.store
    updateGlobal = globalState.updateGlobal
  }

  const { checkoutOpen, cartTotal, itemsInCart, cartInitialised } = store
  const size = '26px'

  return (
    <Box
      id="cartButton"
      height={'100%'}
      width={'50px'}
      marginBottom={'12px !important'}
      onClick={() => {
        // if (!cartInitialised) {
        //   return
        // }
        checkoutOpen ? (
          updateGlobal({
            checkoutOpen: false
            // showPayment: true,
          })
        ) : (
          updateGlobal({
            cartOpen: true
          })
        )
      }}
    >
      {/* {cartInitialised && itemsInCart && ( */}
        <IconButton
          // isDisabled={!cartInitialised}
          style={{ position: 'relative !important' }}
          colorScheme={'black'}
          aria-label={'Shopping Cart'}
          size={'sm'}
          padding={'unset !important'}
          icon={
            <>
              <Image src="/images/basket.png" mb={6} height={size} loading='eager' title="Shopping Basket" alt="Shopping Basket" />
              <Box
                as={'span'}
                color={'white'}
                position={'absolute'}
                top={'11px'}
                right={'15px'}
                fontSize={'0.5rem'}
                borderRadius={'llg'}
                zIndex={9999}
                p={'1px'}
              >
                {itemsInCart ? cartTotal.productQuantity : " "}
              </Box>
            </>
          }
        />
      {/* )} */}
    </Box>
  )
}
